export default function InitImageLightbox() {
	document.addEventListener('DOMContentLoaded', init);
}

function init() {
	const galleries = document.querySelectorAll('.section-homefloorplans .wp-block-gallery');
	if (!galleries.length) return;

	// Collect all image sources
	const images = [];
	galleries.forEach((gallery) => {
		gallery.querySelectorAll('.wp-block-image a').forEach((link) => {
			const href = link.getAttribute('href');
			if (!href || !href.match(/\.(jpe?g|png|gif|webp|svg)(\?.*)?$/i)) return;
			const alt = link.querySelector('img')?.alt || '';
			images.push({ src: href, alt });
		});
	});

	if (!images.length) return;

	let currentIndex = 0;

	// Create lightbox element
	const lightbox = document.createElement('div');
	lightbox.className = 'image-lightbox';
	lightbox.innerHTML = `
		<div class="image-lightbox__overlay"></div>
		<div class="image-lightbox__content">
			<button class="image-lightbox__close" aria-label="Close image">&times;</button>
			<img class="image-lightbox__img" src="" alt="">
			<div class="image-lightbox__nav">
				<button class="image-lightbox__btn image-lightbox__btn--prev" aria-label="Previous image">
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</button>
				<button class="image-lightbox__btn image-lightbox__btn--next" aria-label="Next image">
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
				</button>
			</div>
		</div>
	`;
	document.body.appendChild(lightbox);

	const overlay = lightbox.querySelector('.image-lightbox__overlay');
	const closeBtn = lightbox.querySelector('.image-lightbox__close');
	const img = lightbox.querySelector('.image-lightbox__img');
	const prevBtn = lightbox.querySelector('.image-lightbox__btn--prev');
	const nextBtn = lightbox.querySelector('.image-lightbox__btn--next');

	function show(index) {
		currentIndex = index;
		img.src = images[currentIndex].src;
		img.alt = images[currentIndex].alt;
	}

	function open(index) {
		show(index);
		lightbox.classList.add('is-active');
	}

	function close() {
		lightbox.classList.remove('is-active');
		img.src = '';
	}

	// Bind gallery links
	let i = 0;
	galleries.forEach((gallery) => {
		gallery.querySelectorAll('.wp-block-image a').forEach((link) => {
			const href = link.getAttribute('href');
			if (!href || !href.match(/\.(jpe?g|png|gif|webp|svg)(\?.*)?$/i)) return;
			const idx = i++;
			link.addEventListener('click', (e) => {
				e.preventDefault();
				open(idx);
			});
		});
	});

	prevBtn.addEventListener('click', () => {
		show(currentIndex <= 0 ? images.length - 1 : currentIndex - 1);
	});

	nextBtn.addEventListener('click', () => {
		show(currentIndex >= images.length - 1 ? 0 : currentIndex + 1);
	});

	closeBtn.addEventListener('click', close);
	overlay.addEventListener('click', close);
	document.addEventListener('keydown', (e) => {
		if (!lightbox.classList.contains('is-active')) return;
		if (e.key === 'Escape') close();
		if (e.key === 'ArrowLeft') show(currentIndex <= 0 ? images.length - 1 : currentIndex - 1);
		if (e.key === 'ArrowRight') show(currentIndex >= images.length - 1 ? 0 : currentIndex + 1);
	});
}
